/**
 * Swiper navigation — shared sizes and chevron assets for instock tile + want-it-sooner.
 */

export const SWIPER_INSTOCK_NAV_NEXT =
  'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%227%22%20height%3D%2213%22%20viewBox%3D%220%200%207%2013%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M0.882812%2011.3818L6.13281%206.13184L0.882813%200.881835%22%20stroke%3D%22%231B1A18%22%20stroke-width%3D%221.24719%22%20stroke-linecap%3D%22square%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E';

export const SWIPER_INSTOCK_NAV_PREV =
  'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%227%22%20height%3D%2213%22%20viewBox%3D%220%200%207%2013%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M5.87305%200.881836L0.623047%206.13184L5.87305%2011.3818%22%20stroke%3D%22%231B1A18%22%20stroke-width%3D%221.24719%22%20stroke-linecap%3D%22square%22%20stroke-linejoin%3D%22round%22/%3E%3C/svg%3E';

/** Mobile frosted nav button (Figma) */
export const SWIPER_NAV_MOBILE = {
  backdropBlur: '0.885px',
  button: '38.94px',
  padding: '14.16px',
  iconW: '4.646px',
  iconH: '9.292px',
  /** want-it-sooner: half button width for edge alignment */
  edgeOffset: '19.5px',
};

export const swiperNavMobileIconSize = `${SWIPER_NAV_MOBILE.iconW} ${SWIPER_NAV_MOBILE.iconH}`;

export const SWIPER_CF010_AUTOPLAY_ICON_PX = {
  mobile: '35px',
  desktop: '40px',
};
